/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {createGroupOrderParticipant} from '../api'

export const useMutationCreateGroupOrderParticipant = createReactQueryMutationHook('createGroupOrderParticipant', createGroupOrderParticipant)
